import clsx from 'clsx';
import { graphql } from 'gatsby';
import { Section } from '~components/Section';
import { Heading } from '~components/Heading';
import { Button } from '~components/Button';
import { ComponentLink } from '~components/ComponentLink';
import { Image } from '~components/Image';
import { tildeToSoftHyphen } from '~utils/string';

import * as styles from './ComponentHero.module.css';

import type { ContentBlock } from '~components/types';
import type { ContentfulComponentHero } from './types';

type ComponentHeroProps = {
  content: ContentfulComponentHero;
  className?: string;
};

export const ComponentHero: ContentBlock<ComponentHeroProps> = ({
  content: { image, imagePosition, heading, subheading, link },
  className,
  ...sectionProps
}) => (
  <Section {...sectionProps} className={clsx(styles.section, className)}>
    <Image
      className={styles.image}
      style={{ objectPosition: imagePosition ?? '50% 50%' }}
      image={image}
      loading='eager'
    />
    <Heading className={styles.heading} level={1}>
      {tildeToSoftHyphen(heading)}
    </Heading>
    <Heading className={styles.subheading} level={2}>
      {tildeToSoftHyphen(subheading)}
    </Heading>
    <Button className={styles.button} element={<ComponentLink link={link} />}>
      {link.label}
    </Button>
  </Section>
);

export const query = graphql`
  fragment ComponentHero on ContentfulComponentHero {
    __typename
    image {
      ...MixedMedia
    }
    imagePosition
    heading
    subheading
    link {
      ...ComponentLink
    }
  }
`;
